import type { ITask } from '@modules/TasksModule/types';
import useIsBookingGuarded from '../CustomerMfeAdapter/useIsBookingGuarded';

/**
 * Whether a manual booking card has a booking started: its customer-mfe is in
 * Book Job. Read from the close-guard registry, which a card's view joins
 * while it is mounted.
 */
export default function useManualBookingInProgress(
  task: Pick<ITask, 'viewKey'>,
): boolean {
  return useIsBookingGuarded(task.viewKey);
}
